import { TicketsState } from '@pages/support/store/state/tickets.state';
import { ArticlesState } from '@pages/support/store/state/articles.state';
import { TicketState } from '@pages/support/store/state/ticket.state';
import { TicketCountState } from '@pages/support/store/state/ticket-count.state';
import { SupportBannerState } from '@pages/support/store/state/support-banner.state';

export const supportTicketsState = [ArticlesState, TicketState, TicketCountState, TicketsState, SupportBannerState];
